<template>
  <div class="w-100 live-player-modal" @click="closeModal">
    <div
      @click.stop
      ref="sessionDurationContainer"
      class="w-100 position-relative live-player-modal-container"
    >
      <div class="live-players-modal-header">
        <div class="d-flex align-items-center flex-column">
          <div class="d-flex align-items-center">
            <span class="d-block status-dot active me-2"></span>
            <h4>Live Player</h4>
          </div>
        </div>

        <button class="close-button" @click="closeModal">
          <span></span>
          <span></span>
        </button>
      </div>
      <div
        v-if="totalLive > 0"
        class="d-flex align-items-center justify-content-start w-100 px-4 header-separator"
      >
        <small class="d-block me-2 num-of-live-players"
          ><img
            class="me-2"
            width="15"
            height="15"
            src="/svg/players.svg"
          /><small>{{ totalLive }}</small>
        </small>
        <small class="d-block me-2 fs-small text-uppercase text-warning"
          >Skin ID {{ livePlayersToShowModal }} </small
        >
      </div>

      <div class="box large session-box-custom-padding player-duration-modal">
        <SessionDuration
          @totalLive="getTotalLive"
          :limit=1000
          :collapse="false"
          :skin_id="livePlayersToShowModal"
          :customClass="'player-modal'"
          :tab="'live'"
          :showGridFullWidth="true"
        />
      </div>

      <div
        style="min-height: 350px"
        class="loader-container w-100 h-100 d-flex align-items-center justify-content-center"
        v-if="isLoading"
      >
        <Loader />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "./Loader.vue";
import Swal from "sweetalert2";
import SessionDuration from "./SessionDuration.vue";
export default {
  name: "LivePlayersModal",
  computed: {
    ...mapGetters(["isMenuOpen", "livePlayersToShowModal"]),
  },
  components: {
    Loader,
    SessionDuration,
  },
  data() {
    return {
      currentTime: Date.now(),
      isLoading: false,
      isScrollableTop: false,
      isScrollableBottom: false,
      totalLive: 0,
    };
  },
  async mounted() {
    await this.fetchData();
    document.body.style.overflow = "hidden";
  },
  async beforeUnmount() {
    document.body.style.overflow = "";
  },
  methods: {
    getTotalLive(total) {
      this.totalLive = total;
    },
    closeModal() {
      this.$store.commit("setLivePlayerModalOpen", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/style.scss";
@import "@/assets/styles/components/sessionDuration.scss";

$background-dark: #121214;
$background-gradient: linear-gradient(135deg, #1e1e24 0%, #16161c 100%);
$modal-background: rgb(28 28 35);
$button-gradient: linear-gradient(135deg, #2e2e35 0%, #27272e 100%);
$button-hover-gradient: linear-gradient(135deg, #323239 0%, #2d2d34 100%);
$text-primary: rgba(255, 255, 255, 0.92);
$text-secondary: rgba(255, 255, 255, 0.65);
$accent-color: #0a84ff;
$accent-glow: rgba(10, 132, 255, 0.5);
$border-radius: 12px;
$button-radius: 14px;
$transition-speed: 0.3s;

.live-player-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  z-index: 9876543210;
  padding: 0px 0.85rem;
  animation: fadeIn 0.3s ease;
}

.live-player-modal-container {
  width: 90%;
  max-width: 680px;
  max-height: 80vh;
  min-height: 45vh;
  backdrop-filter: blur(20px);
  border-radius: $border-radius;
  overflow: hidden;
  animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  transform-origin: center bottom;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.45rem 0rem 1rem 0rem;
  background: linear-gradient(145deg, #1a2942, #0f1825);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.live-players-modal-header {
  color: white;
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 1rem;
  font-size: 0.685rem;
  align-items: center;
}

.close-button {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  transition: all $transition-speed ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  span {
    position: absolute;
    width: 14px;
    height: 1px;
    background: $text-primary;
    transform-origin: center;

    &:first-child {
      transform: rotate(45deg);
    }

    &:last-child {
      transform: rotate(-45deg);
    }
  }
}

.live-player-container {
  overflow: auto;
  max-height: 80vh;
  min-height: 45vh;
  padding: 1rem;
  scrollbar-width: thin ;
  scrollbar-color: #505075 #153145 ;
  grid-template-columns: 1fr ;
  height: fit-content;
  place-content: flex-start;
}

.session-card {
  font-size: 0.8rem;
  height: fit-content;

  @media (max-width: 767px) {
    font-size: 0.95rem;
  }
}

// Animations
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(30px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.no-data-players-live {
  position: relative;
  top: 0;
  left: 0;
  transform: none;
  min-height: 350px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #ff4757;
  transition: background-color 0.3s ease;
  animation: pulse 2s infinite;
}

.status-dot.active {
  background-color: #2ed573;
  box-shadow: 0 0 12px rgba(46, 213, 115, 0.4);
}

.status-text {
  color: #a4b0be;
  font-size: 0.875rem;
}

.total-players {
  color: #2ed573;
  margin: 0px 5px ;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(69, 224, 38, 0.7);
  }

  70% {
    transform: scale(1.3);
    box-shadow: 0 0 0 7px rgba(69, 224, 38, 0);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(69, 224, 38, 0);
  }
}

.num-of-live-players {
  text-transform: uppercase;
  font-weight: bold;
  color: #c7aeae;
}

.connection-id-value {
  @media (max-width: 650px) {
    display: none ;
  }
}

.created_at-value,
.ping_at_at-value,
.duration-value {
  @media (max-width: 650px) {
    font-size: 14px ;
    width: 32% ;
  }
}

.duration-title {
  @media (max-width: 650px) {
    text-align: end ;
    max-width: 100% ;
  }
}

.dynamic-justify {
  justify-content: flex-start;
  @media (max-width: 650px) {
    justify-content: flex-end;
  }
}

.fs-small {
  height: 21px;
  line-height: 1;
  position: relative;
  top: 0;
  display: flex ;
  align-items: flex-end;
  /* overflow: visible; */
  width: auto;
}

.shadow-top-live-player {
  position: absolute;
  left: 0;
  right: 0;
  height: 15px;
  z-index: -1;
  width: 100%;
  pointer-events: none;
  top: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), transparent);
}

.shadow-bottom-live-player {
  bottom: 0;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  height: 15px;
  z-index: -1;
  pointer-events: none;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent);
}

.header-separator {
  border-bottom: 2px solid #8989899e;
  width: calc(100% - 40px) ;
  padding: 0px 0px 10px 0px ;
}
.session-box-custom-padding.player-duration-modal {
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}
</style>
